import './accordion.scss';
import './accordion.html.twig';

export default function () {
  const el = document.querySelectorAll('.accordion, .event-agenda');
  if (!el) {
    return;
  }

  Array.prototype.forEach.call(el, function (acc) {
    const links = acc.querySelectorAll('a');
    if (links) {
      Array.prototype.forEach.call(links, function (link) {
        link.setAttribute('tabindex', '-1');
      });
    }
    const accordions = acc.querySelectorAll('.accordion__item-title');
    Array.prototype.forEach.call(accordions, function (accordion) {
      accordion.addEventListener('click', () => {
        accordion.classList.toggle('accordion--active');
        const panel = accordion.nextElementSibling;

        if (accordion.classList.contains('accordion--active')) {
          accordion.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');
        } else {
          accordion.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
        }

        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        }

        const accordionLinks = panel.querySelectorAll('a');
        if (accordionLinks) {
          Array.prototype.forEach.call(accordionLinks, function (link) {
            if (accordion.classList.contains('accordion--active')) {
              link.setAttribute('tabindex', '0');
            } else {
              link.setAttribute('tabindex', '-1');
            }
          });
        }
      });
    });
  });
}
